import React from 'react';
import { ListItem, ListItemText, Grid } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import InfoIcon from '@mui/icons-material/Info';
import Cancel from '@mui/icons-material/Cancel';
import CampaignIcon from '@mui/icons-material/Campaign';

const AlertListItem = ({ alert, clickHandler, actionsComponent }) => {
  const ActionsComponent = actionsComponent;
  const alertTypes = {
    Failure: <Cancel sx={{ marginRight: '10px', color: 'red', fontSize: 45 }} />,
    Success: <CheckCircleIcon sx={{ marginRight: '10px', color: 'green', fontSize: 45 }} />,
    Announcement: <CampaignIcon sx={{ marginRight: '10px', color: '#B0C4DE', fontSize: 45 }} />,
    Warning: <InfoIcon sx={{ marginRight: '10px', color: 'orange', fontSize: 45 }} />,
  };

  return (
    <ListItem sx={{ paddingLeft: '0', paddingRight: '0' }}>
      <Grid container>
        <Grid
          sx={{
            width: '15%',
            display: 'flex',
            alignItems: 'center',
          }}
        >
          {alertTypes[alert.type] ?? <InfoIcon sx={{ marginRight: '10px', color: 'gray', fontSize: 45 }} />}
        </Grid>
        <Grid sx={{ width: '70%' }}>
          <ListItemText
            primary={alert.title}
            secondary={
              <>
                <div dangerouslySetInnerHTML={{ __html: alert.message }} />
                <div>{new Date(alert.createdOn).toLocaleString()}</div>
              </>
            }
          />
        </Grid>
        <Grid sx={{ width: '15' }}>
          <ActionsComponent alert={alert} clickHandler={clickHandler} />
        </Grid>
      </Grid>
    </ListItem>
  );
};

export default AlertListItem;
